import { registerPlugin } from '@capacitor/core'
import { isNativePlatform } from '@/platform/platform'

interface NativeSyncPlugin {
  configure(options: {
    endpoint: string
    fallbackEndpoint?: string
    workspaceId: string
    deviceId: string
  }): Promise<void>
  requestSync(): Promise<void>
  cancel(): Promise<void>
}

const NativeSync = registerPlugin<NativeSyncPlugin>('NativeSync')

// WorkManager-driven background push. Insurance for operations that remain
// queued when the WebView is killed; the in-page sync engine stays primary.
export const nativeSync = {
  async configure(options: { endpoint: string; fallbackEndpoint?: string; workspaceId: string; deviceId: string }) {
    if (!isNativePlatform()) return
    try {
      await NativeSync.configure(options)
    } catch (error) {
      console.warn('NativeSync configure failed', error)
    }
  },
  async requestSync() {
    if (!isNativePlatform()) return
    try {
      await NativeSync.requestSync()
    } catch (error) {
      console.warn('NativeSync requestSync failed', error)
    }
  },
  async cancel() {
    if (!isNativePlatform()) return
    try {
      await NativeSync.cancel()
    } catch (error) {
      console.warn('NativeSync cancel failed', error)
    }
  },
}
